function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "25",
  height: "17",
  viewBox: "0 0 512 336",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M512.001 251.862H0v75.034a8.829 8.829 0 008.828 8.828h494.345a8.829 8.829 0 008.828-8.828v-75.034z",
  fill: "#FF4B55"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.001 168H0V9.103A8.829 8.829 0 018.828.275h494.345a8.829 8.829 0 018.828 8.828V168z",
  fill: "#FFE15A"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#41479B",
  d: "M0 168h512v83.862H0z"
})));